// Note: This method is designed to work with arrays that contain unique values e.g [1, 2, 3], [5, 2 ,6]
// it returns false for [1, 1, 2], [1, 1, 2] because the arrays aren't unique

export const areUniqueArraysEqual = <T>(array1: T[], array2: T[]): boolean => {
    const set1 = new Set(array1);
    const set2 = new Set(array2);

    if (
        array1.length !== set1.size ||
        array2.length !== set2.size ||
        set1.size !== set2.size
    ) {
        return false;
    }

    return [...set1].every((item) => set2.has(item));
};

type field = string | string[] | { Note: string }[];

export const normalizeReviewComments = (input?: field): string => {
    if (!input) return '';
    if (Array.isArray(input)) {
        if (typeof input[0] === 'string') {
            return (input as string[]).join('\n');
        }
        return (input as { Note: string }[]).map((n) => n.Note).join('\n');
    }
    return input.split(/\r?\n/).filter(Boolean).join('\n');
};

export const normalizeComments = (input?: string | string[]): string[] => {
    if (!input) return [];
    if (Array.isArray(input)) {
        return input.flatMap((item) => item.split(/\r?\n/).filter(Boolean));
    }
    return input.split(/\r?\n/).filter(Boolean);
};
